import React from 'react';
import { Badge } from 'reactstrap';

interface Props {
  provider: string;
  device?: string | null;
}

const ProviderDeviceChip: React.FC<Props> = ({ provider, device }) => {
  const label = device ? `${provider} · ${device}` : provider;
  return (
    <Badge color="secondary" pill data-testid="provider-device-chip">
      {label}
    </Badge>
  );
};

export default ProviderDeviceChip;
